import React, {Component} from 'react'
import CharmSketch from './CharmSketch'
import P5Wrapper from "react-p5-wrapper";


class Charm extends Component{

    //to keep the sketch from updating every time the color wheel or IDE is updated
    shouldComponentUpdate = (nextProps) => {
        // console.log(nextProps, this.props)
        // console.log(this.shallowEqual(nextProps, this.props))
        return !this.shallowEqual(nextProps, this.props)
    }

    shallowEqual = (objA, objB) => {
        if (objA === objB) {
          return true;
        }
      
        if (typeof objA !== 'object' || objA === null ||
            typeof objB !== 'object' || objB === null) {
          return false;
        }
      
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
      
        if (keysA.length !== keysB.length) {
          return false;
        }
      
        // Test for A's keys different from B.
        var bHasOwnProperty = hasOwnProperty.bind(objB);
        for (var i = 0; i < keysA.length; i++) {
          if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
            return false;
          }
        }
      
        return true;
    }
    

    render(){
        return (<P5Wrapper sketch={CharmSketch} frames_json={this.props.data} loopCount={this.props.loopCount} pauseCode={this.props.pauseCode} pixel_size={this.props.pixel_size}/>)

    }

}

export default Charm